<nav class="header-class bg-color-header z-[999] w-full text-gray-700">
    <div class="mx-auto flex flex-wrap items-center justify-between px-2 py-2">
        <div class="flex items-center gap-2">
            <div
                (click)="toggleSidebar()"
                class="ml-1 hidden cursor-pointer md:block">
                <i class="pi pi-bars secondary-text text-2xl md:text-3xl"></i>
            </div>

            <a class="ml-4 flex items-center md:hidden">
                <img
                    [routerLink]="['/easy/dashboard/home']"
                    src="assets/logo/hairstyleclub-full-logo.png"
                    class="h-7 w-auto cursor-pointer object-contain"
                    alt="Hair Style Club" />
            </a>
        </div>

        <div class="flex items-center gap-4">
            <div class="flex items-center gap-2">
                <!-- <app-subscription-warning-widget /> -->

                <app-header-quick-settings [isEasyMode]="true" />
            </div>
            <app-easy-profile-dropdown />
        </div>
    </div>
</nav>
